/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignInterviewSettingsUpdate } from '../../axios/campaignInterviewSettingsUpdate'
import type {
	CampaignInterviewSettingsUpdateError,
	CampaignInterviewSettingsUpdatePathParams,
	CampaignInterviewSettingsUpdateRequest,
	CampaignInterviewSettingsUpdateResponse,
} from '../../types/CampaignInterviewSettingsUpdate'

export const campaignInterviewSettingsUpdateMutationKey = () =>
	[{ url: '/interview-scheduling/campaigns/:campaign/interview-settings' }] as const

export type CampaignInterviewSettingsUpdateMutationKey = ReturnType<typeof campaignInterviewSettingsUpdateMutationKey>

export type CampaignInterviewSettingsUpdateVariables = {
	campaign: CampaignInterviewSettingsUpdatePathParams['campaign']
	data: CampaignInterviewSettingsUpdateRequest
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignInterviewSettingsController.php CampaignInterviewSettingsController::update */
export function useCampaignInterviewSettingsUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignInterviewSettingsUpdateResponse,
		AxiosError<CampaignInterviewSettingsUpdateError>,
		CampaignInterviewSettingsUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignInterviewSettingsUpdateMutationKey(),
		mutationFn: ({ campaign, data }: CampaignInterviewSettingsUpdateVariables) =>
			campaignInterviewSettingsUpdate(campaign, data, config).then(res => res.data),
		...options,
	})
}
